
import {getBonusesHistory} from '../api/getBonusesHistory';
import {setGetBonusesHistoryAction} from '../action';

const setGetBonusesHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBonusesHistory(params);
    
            if (data.status === 'success') {
                dispatch(setGetBonusesHistoryAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetBonusesHistory
}